import { AuthActionTypes } from 'src/actions/authActions';
import { IMyCouponsItem } from 'src/components/account/account.interface';
import {
  ConsumerAccountStatusEnum,
  UserStatusEnum,
} from 'src/shared/enums/user.enum';
import { IUser } from 'src/shared/models';
import { authTypes } from 'src/types/authTypes';

export interface AuthState {
  accessToken: string | null;
  impersonate: boolean;
  refreshToken: string | null;
  user: IUser | null;
  userPoints: number | null;
  userCoupons: IMyCouponsItem[];
  userStatus: UserStatusEnum | null;
  accountStatus: ConsumerAccountStatusEnum | null;
  accountSubscription: boolean;
  hubCustomer: boolean | null;
}

const initialState: AuthState = {
  accessToken: null,
  impersonate: false,
  refreshToken: null,
  user: null,
  userPoints: null,
  userCoupons: [],
  userStatus: null,
  accountStatus: null,
  accountSubscription: false,
  hubCustomer: null,
};

export function authReducer(
  state = initialState,
  action: AuthActionTypes,
): AuthState {
  switch (action.type) {
    case authTypes.AUTH_IMPERSONATE:
    case authTypes.AUTH_RESET_USER_STATUS:
    case authTypes.AUTH_SET_INITIAL_USER:
    case authTypes.AUTH_SET_TOKENS:
    case authTypes.AUTH_UPDATE_USER_DATA:
    case authTypes.AUTH_USER_DECLINED:
    case authTypes.AUTH_USER_LOGGED:
    case authTypes.AUTH_UPDATE_USER_POINTS:
    case authTypes.AUTH_UPDATE_USER_COUPONS:
    case authTypes.AUTH_ACCOUNT_STATUS:
    case authTypes.AUTH_ACCOUNT_SUBSCRIPTION:
    case authTypes.AUTH_PROFILE_COMPLETED:
      return {
        ...state,
        ...action.payload,
      };
    case authTypes.AUTH_LOGOUT:
      return {
        ...initialState,
      };
    case authTypes.AUTH_UPDATE_NEWSLETTER_SUBSCRIPTION:
      const { newsletterSubscription } = action.payload;
      state.user.salesforce.newsletterSubscription = newsletterSubscription;
      return { ...state };
    case authTypes.AUTH_MC_SUBSCRIPTION:
      return {
        ...state,
        user: {
          ...state.user,
          mcSubscriptionStatus: action.payload.mcSubscriptionStatus,
          mcSegmentedSubscription: action.payload.mcSegmentedSubscription,
        },
      };
    case authTypes.AUTH_SET_PROFILING_BANNER_STATUS:
      return {
        ...state,
        user: {
          ...state.user,
          temporalData: {
            ...state.user.temporalData,
            profilingBannerStatus: action.payload.profilingBannerStatus,
          },
        },
      };
    case authTypes.AUTH_SET_TERMS_ACCEPTED:
      return {
        ...state,
        user: {
          ...state.user,
          termsAccepted: action.payload.termsAccepted,
        },
      };
    case authTypes.AUTH_SET_USER_STATUS:
      return {
        ...state,
        user: {
          ...state.user,
          userStatus: action.payload.userStatus,
        },
      };
    case authTypes.AUTH_SET_DERMO_ONBOARDING:
      return {
        ...state,
        user: {
          ...state.user,
          temporalData: {
            ...state.user.temporalData,
            dermoOnboarding: action.payload.dermoOnboarding,
          },
        },
      };
    case authTypes.AUTH_SET_IS_DERMO_USER:
      return {
        ...state,
        user: {
          ...state.user,
          dermo: {
            idDermoRole: action.payload.idDermoRole,
            isDermo: action.payload.isDermo,
            dermoStatus: action.payload.dermoStatus,
          },
        },
      };
    case authTypes.AUTH_SET_USER_SPECIALTY:
      return {
        ...state,
        user: {
          ...state.user,
          specialty: action.payload.userSpecialty,
          roleSpecialty: action.payload.roleSpecialty
            ? action.payload.roleSpecialty
            : state.user.roleSpecialty,
        },
      };
    case authTypes.AUTH_SET_USER_ROLE:
      return {
        ...state,
        user: {
          ...state.user,
          roles: {
            ...state.user.roles,
            roles: action.payload.roles
              ? action.payload.roles.roles
              : state.user.roles.roles,
          },
        },
      };
    default:
      return state;
  }
}
